/**
 * TanStack Query hooks for `creative-preview-url`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	creativePreviewUrlQueryKeys,
	type CreateCreativePreviewUrlBody,
	type ListCreativePreviewUrlResponse,
	type CreativePreviewUrlRow,
} from "./api";

export function useCreativePreviewUrlList(): UseQueryResult<ListCreativePreviewUrlResponse, Error> {
	return useQuery({
		queryKey: creativePreviewUrlQueryKeys.list(),
		queryFn: list,
	});
}

export function useCreativePreviewUrlCreate(): UseMutationResult<CreativePreviewUrlRow, Error, CreateCreativePreviewUrlBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: creativePreviewUrlQueryKeys.all });
		},
	});
}

export function useCreativePreviewUrlDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: creativePreviewUrlQueryKeys.all });
		},
	});
}
